import React from 'react';
import { TicketCheck, MessageSquareMore, ExternalLink } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { SEOHead } from '../components/SEOHead';

export default function ContactPage() {
  return (
    <div>
      <SEOHead
        title="Support — Déposer un ticket"
        description="Déposez un ticket de support auprès de Ptitservices.com. Facture, devis, réclamation : nos équipes vous recontacteront dès que possible."
        path="/contact"
      />

      <section className="bg-[linear-gradient(135deg,hsla(195,20%,97%,1)_0%,hsla(182,40%,94%,1)_55%,hsla(195,20%,97%,1)_100%)] py-12 sm:py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center">
          <Badge className="mb-4 px-5 py-2 text-base font-semibold rounded-full bg-[hsl(var(--primary))] text-white hover:bg-[hsl(var(--primary))]/90">Support</Badge>
          <h1 className="font-['Space_Grotesk'] text-3xl sm:text-4xl font-semibold tracking-tight mb-4">Support client</h1>
          <p className="text-muted-foreground max-w-xl mx-auto text-base sm:text-lg">
            Vous avez une demande particulière ? Facture, devis, réclamation... N'hésitez pas à nous laisser un ticket, nos équipes vous contacteront dès que possible.
          </p>
        </div>
      </section>

      <section className="py-8 sm:py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <Card className="p-6 sm:p-8 flex flex-col sm:flex-row items-start gap-5 bg-[hsl(var(--brand-mint))]/20 border-0">
            <div className="w-14 h-14 rounded-xl bg-[hsl(var(--primary))] flex items-center justify-center flex-shrink-0">
              <MessageSquareMore className="h-7 w-7 text-white" />
            </div>
            <div>
              <h2 className="font-['Space_Grotesk'] font-semibold text-xl mb-2">Une demande particulière ?</h2>
              <p className="text-sm text-muted-foreground leading-relaxed">
                Besoin d'une facture, d'un duplicata de devis, d'un justificatif pour votre déclaration d'impôts, 
                ou vous souhaitez faire une réclamation ? Déposez un ticket ci-dessous. 
                Nos équipes traiteront votre demande et vous recontacteront dans les meilleurs délais.
              </p>
            </div>
          </Card>
        </div>
      </section>

      <section className="py-8 sm:py-12">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 text-center">
          <h2 className="font-['Space_Grotesk'] text-xl sm:text-2xl font-semibold tracking-tight mb-8">Déposer un ticket</h2>
          <Card className="p-6 sm:p-8 hover:shadow-lg transition-shadow">
            <div className="w-16 h-16 rounded-2xl bg-[hsl(var(--primary))] flex items-center justify-center mx-auto mb-4">
              <TicketCheck className="h-8 w-8 text-white" />
            </div>
            <h3 className="font-['Space_Grotesk'] text-lg font-semibold mb-2">Support Ptitservices</h3>
            <p className="text-sm text-muted-foreground mb-5">
              Déposez votre ticket, nos équipes vous recontacteront dès que possible.
            </p>
            <a href="https://erp.artois.ptitservices.com/ptslievin/public/ticket/index.php?entity=1" target="_blank" rel="noopener noreferrer">
              <Button className="w-full bg-[hsl(var(--primary))] hover:bg-[hsl(var(--primary))]/90 text-white" size="lg">
                Ouvrir le formulaire de ticket
                <ExternalLink className="ml-2 h-4 w-4" />
              </Button>
            </a>
            <p className="text-xs text-muted-foreground mt-4">Le formulaire s'ouvre dans un nouvel onglet. Vous recevrez un suivi par email.</p>
          </Card>
        </div>
      </section>
    </div>
  );
}
